import type { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';
import { ErrorBanner } from './ErrorBanner';
import { EmptyState } from './EmptyState';

type Props = {
  isLoading: boolean;
  error: string | null;
  isEmpty?: boolean;
  emptyMessage?: string;
  loadingVariant?: 'block' | 'inline';
  children: ReactNode;
};

export function AsyncState({
  isLoading,
  error,
  isEmpty,
  emptyMessage,
  loadingVariant = 'block',
  children,
}: Props) {
  if (error) return <ErrorBanner message={error} />;

  if (isLoading) {
    return loadingVariant === 'inline' ? (
      <div className='flex items-center justify-center py-10 gap-2 text-muted-foreground'>
        <Loader2 className='w-4 h-4 animate-spin' />
        <span className='text-sm'>Загрузка данных...</span>
      </div>
    ) : (
      <div className='flex items-center justify-center py-12'>
        <Loader2 className='w-5 h-5 animate-spin text-muted-foreground' />
      </div>
    );
  }

  if (isEmpty) return <EmptyState message={emptyMessage} />;

  return <>{children}</>;
}
